import {Component, OnInit} from '@angular/core';
import {DataService} from "../services/data.service";
import {ApiService} from "../services/api.service";
import {Setting} from "../type/setting";

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {

    node = 'setting';
    settings: [Setting];

    isChecked = false;
    checkedList = [];

    constructor(private dataService: DataService,
                private apiService: ApiService) {
    }

    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    resetData() {
        this.getAll();
        this.isChecked = false;
        this.checkedList = [];
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.settings = [Setting];
                    } else {
                        this.settings = response.json().data;
                    }
                },
                (error) => {
                    this.settings = [Setting];
                }
            );
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete Setting');
                    } else {
                        alert('Setting Deleted Successfully');
                    }
                    this.resetData();
                });
        }
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.settings.map(function (a) {
                return a.setting_id;
            });
        } else {
            this.checkedList = [];
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/settings/settings.component.ts